// extracted by mini-css-extract-plugin
module.exports = {"hideSmallScreen":"wO","modalWrapperContainer":"xO","modalClickHandlerWrapper":"yO","modalWrapper":"zO","isModal":"AO"};